import { use } from "react";

import { ModalContext, IModalContext } from "@/contexts/ModalContext/context";

export const useModal = (): IModalContext => {
	const context = use(ModalContext);
	if (!context)
		throw new Error("useModal must be used within a ModalProvider");
	return context;
};
